import React from "react";
import { Input } from "antd";
import { useDispatch, useSelector } from "react-redux";
import {
  setDigitalServiceCommentQuestion1,
  setDigitalServiceCommentQuestion2
} from "../../../redux/actions/digitalServiceAction";
import { setDigitalServiceResponse } from "../../../redux/actions/feedbackActions";
import { useMediaQuery } from "react-responsive";
const translations = {
  English: {
    title: "Digital collaboration",
    question1: "How stable is the M365 service in terms of performance and availability?",
    question2: "How likely are you to recommend the M365 service to others?",
    optional: "(optional)",
    commentsPlaceholder: "Comments"
  },
  Japanese: {
    title: "デジタルコラボレーション",
    question1: "パフォーマンスと可用性の観点から、M365サービスの安定性はどのくらいですか？",
    question2: "他の人にM365サービスを勧める可能性はどのくらいですか？",
    optional: "（任意）",
    commentsPlaceholder: "コメント"
  },
  Chinese: {
    title: "数字化协作",
    question1: "在性能和可用性方面，M365服务的稳定性如何？",
    question2: "您有多大可能性向他人推荐M365服务？",
    optional: "（可选）",
    commentsPlaceholder: "评论"
  },
  Dutch: {
    title: "Digitale samenwerking",
    question1: "Hoe stabiel is de M365-service qua prestaties en beschikbaarheid?",
    question2: "Hoe waarschijnlijk is het dat u de M365-service aan anderen zou aanbevelen?",
    optional: "(optioneel)",
    commentsPlaceholder: "Opmerkingen"
  },
  German: {
    title: "Digitale Zusammenarbeit",
    question1: "Wie stabil ist der M365-Dienst in Bezug auf Leistung und Verfügbarkeit?",
    question2: "Wie wahrscheinlich ist es, dass Sie den M365-Dienst anderen empfehlen würden?",
    optional: "(optional)",
    commentsPlaceholder: "Kommentare"
  },
  Spanish: {
    title: "Colaboración digital",
    question1: "¿Qué tan estable es el servicio M365 en términos de rendimiento y disponibilidad?",
    question2: "¿Qué tan probable es que recomiende el servicio M365 a otros?",
    optional: "(opcional)",
    commentsPlaceholder: "Comentarios"
  },
  French: {
    title: "Collaboration numérique",
    question1: "Quelle est la stabilité du service M365 en termes de performance et de disponibilité ?",
    question2: "Quelle est la probabilité que vous recommandiez le service M365 à d'autres ?",
    optional: "(optionnel)",
    commentsPlaceholder: "Commentaires"
  }
};

const DigitalServiceComponent = () => {
  const dispatch = useDispatch();
  const question1Comment = useSelector((state) => state.digitalService.question1Comment);
  const question2Comment = useSelector((state) => state.digitalService.question2Comment);
  const {
    selectedLanguage,
     } = useSelector((state) => ({
      selectedLanguage: state.language.selectedLanguage,
    }));
  const translation = translations[selectedLanguage];

  const handleQuestion1Change = (e) => {
    const response = e.target.value;
    dispatch(setDigitalServiceCommentQuestion1(response)); 
    dispatch(
      setDigitalServiceResponse(
        "Digital collaboration", 
        "question1", 
        translations['English'].question1, 
        response 
      )
    );
  };
  
  const handleQuestion2Change = (e) => {  
    const response = e.target.value;
    dispatch(setDigitalServiceCommentQuestion2(response)); 
    dispatch(
      setDigitalServiceResponse(
        "Digital collaboration", 
        "question2", 
        translations['English'].question2, 
        response 
      )
    );
  };
  const isMobile = useMediaQuery({ maxWidth: 768 });
  return (
    <section style={isMobile ? {marginRight:'4%',marginTop:"20px"  }:{marginRight:'0%' }}>
      <h4>Digital collaboration</h4>

      <h3 style={{ paddingTop: "50px" }}>
        {translation.question1}
        <p style={{ fontSize: "12px", color: "gray" }}>{translation.optional}</p>
      </h3>
      <Input.TextArea
        placeholder={translation.commentsPlaceholder}
        // style={{ height: "60px", resize: "none" }}
        style={isMobile ? {maxWidth:'95%',height: "60px", resize: "none" }:{maxWidth:'100%',height: "60px", resize: "none" }}
        value={question1Comment}
        onChange={handleQuestion1Change}
      />
      <h3>
        {translation.question2}
        <p style={{ fontSize: "12px", color: "gray" }}>{translation.optional}</p>
      </h3>
      <Input.TextArea
        placeholder={translation.commentsPlaceholder}
        style={isMobile?{height: "60px", resize: "none", }:{height: "60px", resize: "none"}}
        value={question2Comment}
        onChange={handleQuestion2Change}
      />
    </section>
  );
};

export default DigitalServiceComponent;
